import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import * as api from '../utils/api';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Modal = styled.div`
  background: ${p => p.$darkMode ? '#0d1117' : '#fff'};
  width: 90vw;
  max-width: 1200px;
  height: 90vh;
  border-radius: 12px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
`;

const Sidebar = styled.div`
  width: 200px;
  background: ${p => p.$darkMode ? '#161b22' : '#f6f8fa'};
  border-right: 1px solid ${p => p.$darkMode ? '#30363d' : '#d0d7de'};
  display: flex;
  flex-direction: column;
`;

const Tab = styled.div`
  padding: 16px 20px;
  cursor: pointer;
  color: ${p => p.$active ? (p.$darkMode ? '#58a6ff' : '#0969da') : (p.$darkMode ? '#8b949e' : '#57606a')};
  background: ${p => p.$active ? (p.$darkMode ? '#0d1117' : '#fff') : 'transparent'};
  border-left: 3px solid ${p => p.$active ? (p.$darkMode ? '#58a6ff' : '#0969da') : 'transparent'};
  font-weight: ${p => p.$active ? '600' : '400'};
  transition: all 0.2s;
  
  &:hover {
    background: ${p => p.$darkMode ? '#0d1117' : '#fff'};
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  padding: 24px 32px;
  border-bottom: 1px solid ${p => p.$darkMode ? '#30363d' : '#d0d7de'};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h2`
  margin: 0;
  color: ${p => p.$darkMode ? '#e6edf3' : '#24292f'};
  font-size: 24px;
  font-weight: 600;
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${p => p.$darkMode ? '#8b949e' : '#57606a'};
`;

const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 32px;
`;

const Btn = styled.button`
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background: ${p => p.$primary ? 'linear-gradient(135deg, #0969da 0%, #0860ca 100%)' : (p.$darkMode ? '#21262d' : '#f6f8fa')};
  color: ${p => p.$primary ? '#fff' : (p.$darkMode ? '#e6edf3' : '#24292f')};
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s;
  border: ${p => p.$primary ? 'none' : `1px solid ${p.$darkMode ? '#30363d' : '#d0d7de'}`};
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  th, td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid ${p => p.$darkMode ? '#30363d' : '#d0d7de'};
    color: ${p => p.$darkMode ? '#e6edf3' : '#24292f'};
  }
  
  th {
    font-weight: 600;
    background: ${p => p.$darkMode ? '#161b22' : '#f6f8fa'};
  }
  
  tr:hover {
    background: ${p => p.$darkMode ? '#161b22' : '#f6f8fa'};
  }
`;

const Badge = styled.span`
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: ${p => p.$role === 'admin' ? 'rgba(207,34,46,0.1)' : p.$role === 'editor' ? 'rgba(9,105,218,0.1)' : 'rgba(87,96,106,0.1)'};
  color: ${p => p.$role === 'admin' ? '#cf222e' : p.$role === 'editor' ? '#0969da' : '#57606a'};
`;

const Input = styled.input`
  padding: 10px 14px;
  border: 1px solid ${p => p.$darkMode ? '#30363d' : '#d0d7de'};
  border-radius: 8px;
  background: ${p => p.$darkMode ? '#0d1117' : '#fff'};
  color: ${p => p.$darkMode ? '#e6edf3' : '#24292f'};
  font-size: 14px;
  width: 100%;
  
  &:focus {
    outline: none;
    border-color: ${p => p.$darkMode ? '#58a6ff' : '#0969da'};
  }
`;

const Select = styled.select`
  padding: 10px 14px;
  border: 1px solid ${p => p.$darkMode ? '#30363d' : '#d0d7de'};
  border-radius: 8px;
  background: ${p => p.$darkMode ? '#0d1117' : '#fff'};
  color: ${p => p.$darkMode ? '#e6edf3' : '#24292f'};
  font-size: 14px;
  width: 100%;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: ${p => p.$darkMode ? '#58a6ff' : '#0969da'};
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
  
  label {
    display: block;
    margin-bottom: 8px;
    color: ${p => p.$darkMode ? '#e6edf3' : '#24292f'};
    font-weight: 600;
    font-size: 14px;
  }
  
  small {
    display: block;
    margin-top: 6px;
    color: ${p => p.$darkMode ? '#8b949e' : '#57606a'};
    font-size: 12px;
  }
`;

const Card = styled.div`
  background: ${p => p.$darkMode ? '#161b22' : '#f6f8fa'};
  border: 1px solid ${p => p.$darkMode ? '#30363d' : '#d0d7de'};
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
`;

const TokenDisplay = styled.div`
  background: ${p => p.$darkMode ? '#0d1117' : '#fff'};
  border: 1px solid ${p => p.$darkMode ? '#30363d' : '#d0d7de'};
  border-radius: 8px;
  padding: 12px;
  font-family: monospace;
  font-size: 12px;
  color: ${p => p.$darkMode ? '#8b949e' : '#57606a'};
  word-break: break-all;
  max-height: 100px;
  overflow-y: auto;
`;

function UserManagement({ darkMode, onClose, currentUser }) {
  const [tab, setTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [ssoConfig, setSsoConfig] = useState({});
  const [newUser, setNewUser] = useState({ email: '', name: '', role: 'viewer' });
  const [token, setToken] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('auth-token');
    if (token && token !== 'guest-token') {
      api.getUsers().then(setUsers).catch(() => {});
      api.getSSOConfig().then(setSsoConfig).catch(() => {});
    } else {
      const localUsers = JSON.parse(localStorage.getItem('local-users') || '[]');
      const localSSO = JSON.parse(localStorage.getItem('local-sso') || '{}');
      setUsers(localUsers);
      setSsoConfig(localSSO);
    }
  }, []);

  const saveUsers = (updated) => {
    setUsers(updated);
    const token = localStorage.getItem('auth-token');
    if (!token || token === 'guest-token') {
      localStorage.setItem('local-users', JSON.stringify(updated));
    }
  };

  const saveSSO = async (config) => {
    setSsoConfig(config);
    const token = localStorage.getItem('auth-token');
    if (!token || token === 'guest-token') {
      localStorage.setItem('local-sso', JSON.stringify(config));
    } else {
      await api.createSSOConfig(config);
    }
  };

  const addUser = async () => {
    if (!newUser.email || !newUser.name) return alert('Email and name required');
    const user = await api.createUser(newUser.email, newUser.name, newUser.role);
    const updated = [...users, user];
    setUsers(updated);
    saveUsers(updated);
    setNewUser({ email: '', name: '', role: 'viewer' });
  };

  const deleteUser = async (id) => {
    if (!window.confirm('Delete user?')) return;
    await api.deleteUser(id);
    const updated = users.filter(u => u.id !== id);
    setUsers(updated);
    saveUsers(updated);
  };

  const updateRole = async (id, role) => {
    await api.updateUser(id, role);
    const updated = users.map(u => u.id === id ? { ...u, role } : u);
    setUsers(updated);
    saveUsers(updated);
  };

  const generateToken = (userId) => {
    const user = users.find(u => u.id === userId);
    if (!user) return;
    
    const header = btoa(JSON.stringify({ alg: 'HS256', typ: 'JWT' }));
    const payload = btoa(JSON.stringify({
      sub: user.id,
      email: user.email,
      name: user.name,
      role: user.role,
      iat: Math.floor(Date.now() / 1000),
      exp: Math.floor(Date.now() / 1000) + 3600
    }));
    const signature = btoa('mock-signature-' + userId);
    
    setToken(`${header}.${payload}.${signature}`);
  };

  const testOAuth = () => {
    if (!ssoConfig.clientId || !ssoConfig.authUrl) {
      return alert('Configure Client ID and Authorization URL first');
    }
    
    const params = new URLSearchParams({
      client_id: ssoConfig.clientId,
      redirect_uri: ssoConfig.redirectUri || window.location.origin + '/callback',
      response_type: 'code',
      scope: ssoConfig.scope || 'openid profile email'
    });
    
    alert(`OAuth flow would redirect to:\n${ssoConfig.authUrl}?${params.toString()}`);
  };

  return (
    <Overlay onClick={(e) => e.target === e.currentTarget && onClose()}>
      <Modal $darkMode={darkMode}>
        <Sidebar $darkMode={darkMode}>
          <Tab $darkMode={darkMode} $active={tab === 'users'} onClick={() => setTab('users')}>👥 Users</Tab>
          <Tab $darkMode={darkMode} $active={tab === 'sso'} onClick={() => setTab('sso')}>🔐 SSO Config</Tab>
          <Tab $darkMode={darkMode} $active={tab === 'tokens'} onClick={() => setTab('tokens')}>🎫 JWT Tokens</Tab>
        </Sidebar>
        
        <Content>
          <Header $darkMode={darkMode}>
            <Title $darkMode={darkMode}>User Management</Title>
            <CloseBtn $darkMode={darkMode} onClick={onClose}>&times;</CloseBtn>
          </Header>
          
          <Body>
            {tab === 'users' && (
              <>
                <Card $darkMode={darkMode}>
                  <h3 style={{ margin: '0 0 20px 0', color: darkMode ? '#e6edf3' : '#24292f' }}>Add User</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 150px auto', gap: '12px' }}>
                    <Input 
                      $darkMode={darkMode}
                      placeholder="Email"
                      value={newUser.email}
                      onChange={e => setNewUser({ ...newUser, email: e.target.value })}
                    />
                    <Input 
                      $darkMode={darkMode}
                      placeholder="Name"
                      value={newUser.name}
                      onChange={e => setNewUser({ ...newUser, name: e.target.value })}
                    />
                    <Select 
                      $darkMode={darkMode}
                      value={newUser.role}
                      onChange={e => setNewUser({ ...newUser, role: e.target.value })}
                    >
                      <option value="viewer">Viewer</option>
                      <option value="editor">Editor</option>
                      <option value="admin">Admin</option>
                    </Select>
                    <Btn $darkMode={darkMode} $primary onClick={addUser}>Add</Btn>
                  </div>
                </Card>
                
                <Table $darkMode={darkMode}>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(user => (
                      <tr key={user.id}>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>
                          <Select 
                            $darkMode={darkMode}
                            value={user.role}
                            onChange={e => updateRole(user.id, e.target.value)}
                            style={{ width: 'auto', padding: '6px 10px' }}
                          >
                            <option value="viewer">Viewer</option>
                            <option value="editor">Editor</option>
                            <option value="admin">Admin</option>
                          </Select>
                        </td>
                        <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                        <td>
                          <Btn $darkMode={darkMode} onClick={() => deleteUser(user.id)} style={{ padding: '6px 12px' }}>Delete</Btn>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                
                {users.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '40px', color: darkMode ? '#8b949e' : '#57606a' }}>
                    No users yet. Add your first user above.
                  </div>
                )}
              </>
            )}
            
            {tab === 'sso' && (
              <>
                <Card $darkMode={darkMode}>
                  <h3 style={{ margin: '0 0 20px 0', color: darkMode ? '#e6edf3' : '#24292f' }}>OAuth 2.0 Configuration</h3>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Provider</label>
                    <Select 
                      $darkMode={darkMode}
                      value={ssoConfig.provider || ''}
                      onChange={e => saveSSO({ ...ssoConfig, provider: e.target.value })}
                    >
                      <option value="">Select Provider</option>
                      <option value="google">Google</option>
                      <option value="github">GitHub</option>
                      <option value="okta">Okta</option>
                      <option value="auth0">Auth0</option>
                      <option value="azure">Azure AD</option>
                      <option value="custom">Custom</option>
                    </Select>
                  </FormGroup>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Client ID</label>
                    <Input 
                      $darkMode={darkMode}
                      placeholder="your-client-id"
                      value={ssoConfig.clientId || ''}
                      onChange={e => saveSSO({ ...ssoConfig, clientId: e.target.value })}
                    />
                  </FormGroup>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Client Secret</label>
                    <Input 
                      $darkMode={darkMode}
                      type="password"
                      placeholder="your-client-secret"
                      value={ssoConfig.clientSecret || ''}
                      onChange={e => saveSSO({ ...ssoConfig, clientSecret: e.target.value })}
                    />
                  </FormGroup>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Authorization URL</label>
                    <Input 
                      $darkMode={darkMode}
                      placeholder="https://provider.com/oauth/authorize"
                      value={ssoConfig.authUrl || ''}
                      onChange={e => saveSSO({ ...ssoConfig, authUrl: e.target.value })}
                    />
                  </FormGroup>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Token URL</label>
                    <Input 
                      $darkMode={darkMode}
                      placeholder="https://provider.com/oauth/token"
                      value={ssoConfig.tokenUrl || ''}
                      onChange={e => saveSSO({ ...ssoConfig, tokenUrl: e.target.value })}
                    />
                  </FormGroup>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Redirect URI</label>
                    <Input 
                      $darkMode={darkMode}
                      placeholder="https://your-domain.com/callback"
                      value={ssoConfig.redirectUri || ''}
                      onChange={e => saveSSO({ ...ssoConfig, redirectUri: e.target.value })}
                    />
                  </FormGroup>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Scope</label>
                    <Input 
                      $darkMode={darkMode}
                      placeholder="openid profile email"
                      value={ssoConfig.scope || ''}
                      onChange={e => saveSSO({ ...ssoConfig, scope: e.target.value })}
                    />
                    <small>Space-separated scopes</small>
                  </FormGroup>
                  
                  <Btn $darkMode={darkMode} $primary onClick={testOAuth}>Test OAuth Flow</Btn>
                </Card>
              </>
            )}
            
            {tab === 'tokens' && (
              <>
                <Card $darkMode={darkMode}>
                  <h3 style={{ margin: '0 0 20px 0', color: darkMode ? '#e6edf3' : '#24292f' }}>Generate JWT Token</h3>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Select User</label>
                    <div style={{ display: 'flex', gap: '12px' }}>
                      <Select 
                        $darkMode={darkMode}
                        onChange={e => e.target.value && generateToken(e.target.value)}
                      >
                        <option value="">Choose user...</option>
                        {users.map(user => (
                          <option key={user.id} value={user.id}>{user.name} ({user.email})</option>
                        ))}
                      </Select>
                    </div>
                  </FormGroup>
                  
                  {token && (
                    <FormGroup $darkMode={darkMode}>
                      <label>Generated JWT Token</label>
                      <TokenDisplay $darkMode={darkMode}>{token}</TokenDisplay>
                      <small>Token expires in 1 hour. Copy and use in Authorization header: Bearer {'{token}'}</small>
                    </FormGroup>
                  )}
                </Card>
                
                <Card $darkMode={darkMode}>
                  <h3 style={{ margin: '0 0 16px 0', color: darkMode ? '#e6edf3' : '#24292f' }}>JWT Configuration</h3>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>JWT Secret</label>
                    <Input 
                      $darkMode={darkMode}
                      type="password"
                      placeholder="your-jwt-secret-key"
                      defaultValue="mock-secret-key"
                    />
                    <small>Used to sign and verify JWT tokens</small>
                  </FormGroup>
                  
                  <FormGroup $darkMode={darkMode}>
                    <label>Token Expiration</label>
                    <Select $darkMode={darkMode} defaultValue="3600">
                      <option value="1800">30 minutes</option>
                      <option value="3600">1 hour</option>
                      <option value="7200">2 hours</option>
                      <option value="86400">24 hours</option>
                    </Select>
                  </FormGroup>
                </Card>
              </>
            )}
          </Body>
        </Content>
      </Modal>
    </Overlay>
  );
}

export default UserManagement;
